import axios from '../utilities/Axios';

export default {
  getAll: async (filters) => (await axios.get('/admin_users', {params: filters})).data.data,
  banUser: async (_id) => (await axios.patch('/admin_users/ban', _id)).data.data,
  deleteUser: async ({_id}) => (await axios.delete(`/admin_users/${_id}`)).data.data,
  updateUser: async (data) => (await axios.put('/admin_users', data)).data.data,
}
